import { FC, useEffect } from 'react'

import { usePushRegistration } from '@/hooks/usePushRegistration'
import { registerPushRegistrationDisableHandler } from '@/services/PushRegistration/pushRegistrationRef'

export const ConnectedPushRegistration: FC = () => {
    const { disable } = usePushRegistration()

    useEffect(() => {
        registerPushRegistrationDisableHandler(disable)

        return () => registerPushRegistrationDisableHandler(null)
    }, [disable])

    return null
}
